<template>
  <div id="app">
    <div id="sideBar" v-touch:swipe.left="sideBarToggle"
    v-touch:swipe.right="sideBarToggle">
      <div class="menuIcon displayBlockOn-sm" v-on:click="sideBarToggle">
        <div id="nav-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <ul id="menu">
        <li v-for="route in this.returnObject.routes" :key="route.id">
          <router-link :to="route.link" active-class="menuLinkActive" :exact="route.atr">{{route.text}}</router-link>
        </li>
      </ul>
      <img src="~images/logo.png" id="logo"/>
    </div>
    <div id="mainContainer"  v-touch:swipe.left="sideBarToggle">
      <transition name="router-anim">
        <router-view/>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    var returnObject = {
      menuState: 1,
      routes: [
        {id: '1', link: '/', atr: true, text: 'Home'},
        {id: '2', link: '/about', atr: true, text: 'About'},
        {id: '3', link: '/destinations', atr: true, text: 'Destinations'},
        {id: '4', link: '/packages', atr: true, text: 'Packages'},
        {id: '5', link: '/how_do_we_do', atr: true, text: 'How Do We Do'},
        {id: '6', link: '/contact', atr: true, text: 'Contact'}
      ]
    }
    return {
      returnObject
    }
  },
  methods: {
    sideBarToggle: function () {
      if (window.innerWidth < 769) {
        if (this.returnObject.menuState === 1) {
          this.openSideBar()
        } else {
          this.closeSideBar()
        }
      }
    },
    openSideBar: function () {
      var sideBar = document.getElementById('sideBar')
      var menu = document.getElementById('menu')
      var navBar = document.getElementById('nav-icon')
      var mainContainer = document.getElementById('mainContainer')
      var logo = document.getElementById('logo')
      navBar.classList.add('open')
      this.returnObject.menuState = 0
      sideBar.style.width = '70vw'
      mainContainer.style.marginRight = '-70vw'
      mainContainer.style.opacity = 0.7
      setTimeout(() => {
        menu.style.opacity = 1
        logo.style.opacity = 1
      }, 200)
    },
    closeSideBar: function () {
      var sideBar = document.getElementById('sideBar')
      var menu = document.getElementById('menu')
      var navBar = document.getElementById('nav-icon')
      var mainContainer = document.getElementById('mainContainer')
      var logo = document.getElementById('logo')
      navBar.classList.remove('open')
      this.returnObject.menuState = 1
      sideBar.style.width = '40px'
      menu.style.opacity = 0
      logo.style.opacity = 0
      mainContainer.style.opacity = 1
      setTimeout(() => {
        mainContainer.style.marginRight = '0'
      }, 200)
    }
  }
}
window.addEventListener('load', function (event) {
})
</script>
<style lang="scss" scoped>
  @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
  @import "~scssDir/_breakpoints.scss";
  @import "~scssDir/_variables.scss";
  @import "~scssDir/_myAnimations.scss";
  #app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;
    z-index: 1;
    #sideBar {
      width: 40px;
      height: 100vh;
      background-color: $color1;
      color: white;
      font-family: $fontHead;
      font-size: 20px;
      font-weight: 500;
      position: relative;
      padding: 50px 5px;
      display: inline-block;
      float: left;
       z-index: 5;
      overflow: hidden;
      @include transition(width .5s);
      @include media-md {
        width: 20vw !important;
      }
      @include max-height(300px){
          overflow-y:auto;
      }
      .menuIcon {
        padding:10px 0;
        cursor:pointer;
        position: relative;
        #nav-icon {
          width: 25px;
          height: 10px;
          margin: 1px auto;
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
          -webkit-transition: .5s ease-in-out;
          -moz-transition: .5s ease-in-out;
          -o-transition: .5s ease-in-out;
          transition: .5s ease-in-out;
          cursor: pointer;
          display: inline-block;
        }
        #nav-icon span {
          display: block;
          position: absolute;
          height: 2px;
          width: 100%;
          background: $color4;
          border-radius: 9px;
          opacity: 1;
          left: 0;
          -webkit-transform: rotate(0deg);
          -moz-transform: rotate(0deg);
          -o-transform: rotate(0deg);
          transform: rotate(0deg);
          -webkit-transition: .25s ease-in-out;
          -moz-transition: .25s ease-in-out;
          -o-transition: .25s ease-in-out;
          transition: .25s ease-in-out;
        }
        #nav-icon span:nth-child(1) {
          top: 0px;
        }
        #nav-icon span:nth-child(2) {
          top: 8px;
        }
        #nav-icon span:nth-child(3) {
          top: 16px;
        }
        #nav-icon.open span:nth-child(1) {
          top: 8px;
          -webkit-transform: rotate(135deg);
          -moz-transform: rotate(135deg);
          -o-transform: rotate(135deg);
          transform: rotate(135deg);
        }
        #nav-icon.open span:nth-child(2) {
          opacity: 0;
          left: +60vw;
        }
        #nav-icon.open span:nth-child(3) {
          top:8px;
          -webkit-transform: rotate(-135deg);
          -moz-transform: rotate(-135deg);
          -o-transform: rotate(-135deg);
          transform: rotate(-135deg);
        }
      }
      #menu {
        opacity:0;
        list-style: none;
        margin: 0;
        padding: 0;
        padding-left:5px;
        position: relative;
        top: 22%;
        font-size:16px;
        font-weight:400;
        @include transition(opacity .3s);
        @include media-md{
          opacity:1 !important;
          padding-left:10px;
          font-size:18px
        }
        @include media-lg{
          padding-left:30px;
          font-size:20px;
        }
        li {
          padding: 3px 0;
          a {
            @include transition(all 0.5s);
          }
          a:hover {
            margin-left: 10px;
          }
        }
      }
      #logo{
        position: absolute;;
        bottom:70px;
        width:135px;
        opacity:0;
        padding-left:5px;
        @include transition(opacity .3s);
        @include media-md{
          opacity:1 !important;
          padding-left:10px;
          width:125px;
          bottom:60px;
        }
        @include media-lg{
          width:190px;
          padding-left:30px;
          bottom:90px;
        }
        @include max-height(500px){
          bottom:30px;
        }
        @include max-height(400px){
          top:10px;
          bottom: unset;
        }
      }
      #mainContainer {
        width: 700px;
        height: 100vh;
        padding-left:40px;
        @include transition(all .9s);
        @include media-md {
          padding-left:20vw  !important;
          padding-right:20vw !important;
        }
      }
    }

    .menuLinkActive {
      color: $color3;
    }

    .router-anim-enter-active {
      animation: coming .7s;
      animation-delay: 0.5s;
      opacity: 0;
    }

    .router-anim-leave-active {
      animation: going .7s;
    }

    @keyframes going {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(+50px);
        opacity: 0.7;
      }
    }

    @keyframes coming {
      from {
        transform: translateX(+50px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue